import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("line", {
  x1: "4",
  x2: "20",
  y1: "12",
  y2: "12"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("line", {
  x1: "4",
  x2: "20",
  y1: "6",
  y2: "6"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("line", {
  x1: "4",
  x2: "20",
  y1: "18",
  y2: "18"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
const BarsIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  BarsIcon as default
};
//# sourceMappingURL=BarsIcon.vue.es.js.map
